/* eslint-disable */
// reducers
import {
  TOGGLE_LOADING,
  UNAUTHORIZED_DEAL_ROOM,
  FETCH_DEAL_ROOM_CATEGORY_LIST,
  FETCH_DEAL_ROOM_TEMPLATE_LIST,
  FETCH_DEAL_ROOM_CONTENT_LIST,
  FETCH_TEMPLATE_DETAILS,
  FETCH_TEMPLATE_INTRODUCTION,
  FETCH_TEMPLATE_SECTION,
  SECTION_ASSET_SELECTED,
  FETCH_TEMPLATE_SETUP,
  SET_IGNORE_IDS,
  FETCH_DEAL_SETUP,
  FETCH_DEAL_ACCESS_LIST,
  FETCH_DEAL_BUYERS_LIST,
  FETCH_DEAL_SELLERS_LIST,
  DEAL_ROOM_CONTAINER_ACTIVE_OPTION, FETCH_DEAL_INTRODUCTION,
  FETCH_DEAL_DETAILS,
  FETCH_DEAL_SECTION,
  QUICK_FILTERS,
  FETCH_DEAL_SECTION_ASSET_LIST,
  CATEGORY_TYPE,
  SEARCH_KEY,
  STATUS_TYPE,
  SORT_TYPE,
  GET_TIMELINE_LIST,
  GET_TIMELINE_RECAP_LIST,
  GET_DEALROOM_CONTACTS_LIST,
  SEND_MAIL_TO_DEALROOM_CONTACTS_STATUS,
  SCHEDULED_MEETINGS_LIST,
  GET_ZOOM_MEETING_LINK, GET_MILESTONES_LIST, SET_ZOOM_CODE, SET_ZOOM_DETAILS,
  FETCH_DEALROOM_COMMENTS,
  SET_PDF_PAGE_ID,
  GET_MILESTONE_CLIENT_DOCUMENT_LIST,
  GET_MILESTONES_LIST_FRONTEND,
  NAV_ASSET_ID
} from "../../constants/DealRoomActionTypes";

const initialState = {
  loading: false,
  unauthorizedDealRoomUpload: null,
  dealRoomCategories: [],
  dealRoomTemplates: [],
  dealRoomContent: [],
  templateDetails: null,
  templateIntroduction: [],
  templateSection: [],
  templateSetup: null,
  templateSetupCategories: [],
  templateSetupHashtags: [],
  sectionAssetSelected: [],
  sectionAssetIgnoreIDs: [],
  unauthorizedDealRoom: null,
  dealSetUpData: [],
  dealAccessList: [],
  dealBuyersList: [],
  dealSellersList: [],
  dealRoomContainerActiveOption: "Intro",
  dealIntroduction: [],
  dealDetails: null,
  dealSections: [],
  quickFilter: null,
  searchKey: "",
  categoryType: "",
  statusType: "",
  sortType: "",
  drDetails: null,
  timelineList: [],
  timelineRecapList: [],
  dealRoomSelectedContacts: [],
  mailToDRContactsStatus: false,
  meetingsList: [],
  zoomMeetingLink: null,
  milestonesList: [],
  zoomCode: null,
  drComments: [],
  pdfPgaeId: null,
  milestoneClientsDocumentList: [],
  milestonesListFE : [],
  navAssetID: null
};

const dealRoomReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case TOGGLE_LOADING:
      return { ...state, loading: payload };
    case UNAUTHORIZED_DEAL_ROOM:
      return { ...state, unauthorizedDealRoomUpload: payload,unauthorizedDealRoom: payload };
    case FETCH_DEAL_ROOM_CATEGORY_LIST:
      return { ...state, dealRoomCategories: payload };
    case FETCH_DEAL_ROOM_TEMPLATE_LIST:
      return { ...state, dealRoomTemplates: payload };
    case FETCH_DEAL_ROOM_CONTENT_LIST:
      return { ...state, dealRoomContent: payload };
    case FETCH_TEMPLATE_DETAILS:
      return { ...state, templateDetails: payload, drDetails: payload };
    case FETCH_TEMPLATE_INTRODUCTION:
      return { ...state, templateIntroduction: payload };
    case FETCH_TEMPLATE_SECTION:
      return { ...state, templateSection: payload };
    case SECTION_ASSET_SELECTED:
      return { ...state, sectionAssetSelected: payload };
    case FETCH_TEMPLATE_SETUP:
      return { ...state, templateSetup: payload?.data, templateSetupCategories: payload?.categories, templateSetupHashtags: payload?.hashtags };
    case SET_IGNORE_IDS:
      return { ...state, sectionAssetIgnoreIDs: payload };
    case FETCH_DEAL_SETUP:
      return { ...state, dealSetUpData: payload };
    case FETCH_DEAL_ACCESS_LIST:
      return { ...state, dealAccessList: payload };
    case FETCH_DEAL_BUYERS_LIST:
      return { ...state, dealBuyersList: payload };
    case FETCH_DEAL_SELLERS_LIST:
      return { ...state, dealSellersList: payload };
    case DEAL_ROOM_CONTAINER_ACTIVE_OPTION:
      return { ...state, dealRoomContainerActiveOption: payload };
    case FETCH_DEAL_INTRODUCTION:
      return { ...state, dealIntroduction: payload };
    case FETCH_DEAL_DETAILS:
      return { ...state, dealDetails: payload, drDetails: payload };
    case FETCH_DEAL_SECTION:
      return { ...state, dealSections: payload }
    case QUICK_FILTERS:
      return { ...state, quickFilter: payload.id };
    case SEARCH_KEY:
      return { ...state, searchKey: payload };
    case CATEGORY_TYPE:
      return { ...state, categoryType: payload };
    case STATUS_TYPE:
      return { ...state, statusType: payload };
    case SORT_TYPE:
      return { ...state, sortType: payload };
    case GET_TIMELINE_LIST:
      return { ...state, timelineList: payload };
    case GET_TIMELINE_RECAP_LIST:
      return { ...state, timelineRecapList: payload };
    case GET_DEALROOM_CONTACTS_LIST:
      return { ...state, dealRoomSelectedContacts: payload };
    case SEND_MAIL_TO_DEALROOM_CONTACTS_STATUS:
      return { ...state, mailToDRContactsStatus: payload };
    case SCHEDULED_MEETINGS_LIST:
      return { ...state, meetingsList: payload };
    case GET_ZOOM_MEETING_LINK:
      return { ...state, zoomMeetingLink: payload };
    case GET_MILESTONES_LIST:
      return { ...state, milestonesList: payload };
    case SET_ZOOM_CODE:
      return { ...state, zoomCode: payload };
    case SET_ZOOM_DETAILS:
      return { ...state, zoomDetails: payload };
    case FETCH_DEALROOM_COMMENTS:
      return { ...state, drComments: payload };
    case SET_PDF_PAGE_ID:
      return { ...state, pdfPgaeId: payload };
    case GET_MILESTONE_CLIENT_DOCUMENT_LIST:
      return { ...state, milestoneClientsDocumentList: payload };
    case GET_MILESTONES_LIST_FRONTEND:
      return { ...state, milestonesListFE: payload}
    case NAV_ASSET_ID:
      return { ...state, navAssetID: payload}
    default:
      return state;
  }
};
export default dealRoomReducer;
